// extracted by mini-css-extract-plugin
export default {"container":"I6gS8","name":"_4AzY3"};